import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Row, Col } from 'reactstrap';
import { Plus, Trash } from 'react-feather';

const SpecificBrandsSearchModal = ({ isOpen, toggle, onSearch }) => {
  const [brandNames, setBrandNames] = useState(['']);

  const handleAddRow = () => {
    setBrandNames([...brandNames, '']);
  };

  const handleRemoveRow = (index) => {
    const updated = [...brandNames];
    updated.splice(index, 1);
    setBrandNames(updated);
  };

  const handleChange = (index, value) => {
    const updated = [...brandNames];
    updated[index] = value;
    setBrandNames(updated);
  };

  const handleSearch = () => {
    const filteredNames = brandNames.filter((name) => name.trim() !== '');
    onSearch(filteredNames);
    toggle();
  };

  const handleClear = () => {
    setBrandNames(['']);
    onSearch([]);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Search Specific Brands</ModalHeader>
      <ModalBody>
        {brandNames.map((name, index) => (
          <Row key={index} className="mb-2 align-items-center">
            <Col>
              <Input
                type="text"
                placeholder="Enter brand name"
                value={name}
                onChange={(e) => handleChange(index, e.target.value)}
              />
            </Col>
            <Col xs="auto">
              {brandNames.length > 1 && (
                <Button color="danger" outline size="sm" onClick={() => handleRemoveRow(index)}>
                  <Trash size={14} />
                </Button>
              )}
            </Col>
          </Row>
        ))}
        <Button color="primary" outline size="sm" className="mt-2" onClick={handleAddRow}>
          <Plus size={14} /> Add More
        </Button>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClear}>Clear</Button>
        <Button color="primary" onClick={handleSearch}>Search</Button>
      </ModalFooter>
    </Modal>
  );
};

export default SpecificBrandsSearchModal;
